let apiPrefix;
// apiPrefix = "http://120.77.216.30/sdt/";
// apiPrefix = "http://www.tietonggroup.com/sd";
// apiPrefix = "http://120.77.216.30:5001";
apiPrefix = "http://192.168.0.150:5001/";
// apiPrefix = "http://120.77.151.17/sd";
module.exports = {
    apiPrefix,
    // 项目界面展示的版本号
    version: 'v1.0.11',
};
